import * as Actions from "../constants/Auth";

export const signIn = (user) => {
  return {
    type: Actions.SIGNIN,
    payload: user,
  };
};

export const authenticated = (token) => {
  return {
    type: Actions.AUTHENTICATED,
    payload:token,
  };
};

export const signOut = (token) => {
  return {
    type: Actions.SIGNOUT,
    payload: token,
  };
};

export const showAuthMessage = (message) => {
  return {
    type: Actions.SHOW_AUTH_MESSAGE,
    message,
  };
};
